import React from "react";
import "./footer.css";

export function Footer() {
  return (
    <div className="page-footer">
      <a href="https://dictionaryapi.dev/">https://dictionaryapi.dev/</a>
    </div>
  );
}
